/*
  Les cadeaux ne survivent pas au produit qui les a fait naître, et on ne peut
  pas se servir.

  Deux garde-fous, tous les deux nécessaires :

  1. Retrait des orphelins. Sans ça, on retire le filet du panier et il reste
     deux articles à 0 € : le client voit un panier « plein » à 0 €, et le
     bouton payer reste actif pour rien.

  2. Plafond de quantité. Les fiches cadeau sont publiées — il le faut, sinon
     « /cart/add.js » les refuse et les offres ne fonctionnent plus. Mais le
     champ de quantité du panier reste modifiable : on pouvait passer un cadeau
     à 10 et payer zéro. Vérifié le 29 août 2026 : 10 Net Clips offerts pour
     79,95 $. On plafonne donc chaque ligne cadeau au nombre d'articles payants
     du panier — un filet donne droit à un cadeau de chaque, deux filets à deux.
*/
(function () {
  var enCours = false;

  function verifier() {
    if (enCours) return;
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var payantes = panier.items.filter(function (l) { return l.price > 0; });
        var cadeaux = panier.items.filter(function (l) { return l.price === 0; });
        if (!cadeaux.length) return;

        // Combien d'articles payants ? C'est le plafond de chaque cadeau.
        var plafond = 0;
        payantes.forEach(function (l) { plafond += l.quantity; });

        var mise = {};
        if (!payantes.length) {
          // plus rien de payant : les cadeaux partent
          cadeaux.forEach(function (l) { mise[l.key] = 0; });
        } else {
          cadeaux.forEach(function (l) {
            if (l.quantity > plafond) mise[l.key] = plafond;
          });
          if (!Object.keys(mise).length) return;   // rien à corriger
        }

        enCours = true;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: mise })
        }).then(function () {
          var tiroir = document.querySelector('cart-drawer');
          if (!tiroir) { location.reload(); return; }
          return fetch('/?sections=cart-drawer,cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (sections) {
              var lire = function (html, sel) {
                return new DOMParser().parseFromString(html, 'text/html')
                  .querySelector(sel).innerHTML;
              };
              var interieur = document.querySelector('#CartDrawer .drawer__inner');
              if (interieur) interieur.innerHTML = lire(sections['cart-drawer'], '.drawer__inner');
              var bulle = document.getElementById('cart-icon-bubble');
              if (bulle) bulle.innerHTML = lire(sections['cart-icon-bubble'], '.shopify-section');
              tiroir.classList.add('is-empty');
            });
        }).then(function () { enCours = false; })
          .catch(function () { enCours = false; });
      })
      .catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', verifier);
  // Le thème publie un événement à chaque changement de panier ; s'il n'est pas
  // encore chargé, on se rabat sur l'observation des clics du tiroir.
  document.addEventListener('click', function (e) {
    if (e.target.closest('cart-remove-button, .quantity__button')) {
      setTimeout(verifier, 1400);
    }
  }, true);
})();
